import React from "react";
import { useSelector } from "react-redux";
import { getElementById } from "../utils/styleUtils";

export const CustomTextTitle = ({ instanceId }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Title element not found</div>;
  }

  const elementStyle = element.style || {};

  const getTitleStyles = () => {
    return {
      fontSize: elementStyle.fontSize || "1.5rem",
      fontFamily: elementStyle.fontFamily || "inherit",
      fontWeight: elementStyle.fontWeight || "600",
      fontStyle: elementStyle.fontStyle || "normal",
      textAlign: elementStyle.textAlign || "left",
      textTransform: elementStyle.textTransform || "none",
      letterSpacing: elementStyle.letterSpacing || "normal",
      lineHeight: elementStyle.lineHeight || "1.2",
      color: elementStyle.color || "#212529",
      backgroundColor: elementStyle.backgroundColor || "transparent",
      padding: elementStyle.padding || "0",
      marginLeft: elementStyle.marginLeft || "0",
      marginRight: elementStyle.marginRight || "0",
      marginTop: elementStyle.marginTop || "0",
      marginBottom: elementStyle.marginBottom || "1rem",
      borderRadius: elementStyle.borderRadius || "0",
      borderStyle: elementStyle.borderStyle || "none",
      borderColor: elementStyle.borderColor || "#ced4da",
      borderWidth: elementStyle.borderWidth || "0",
      textDecoration: elementStyle.textDecoration || "none",
      textShadow: elementStyle.textShadow || "none",
      width: elementStyle.width || "100%",
    };
  };

  const HeadingTag = elementStyle.headingLevel || "h1";

  return (
    <HeadingTag style={getTitleStyles()}>
      {elementStyle.titleText || "Form Title"}
    </HeadingTag>
  );
};
